// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper {
  flex-direction: row;
  margin: 10px;
  display: flex;
}

.stepper:after {
  content: "";
  opacity: .5;
  text-align: center;
  vertical-align: middle;
  background: #00000040;
  border-radius: 1px 0 0 1px;
  flex-grow: 1;
  align-self: center;
  height: 2px;
  line-height: 1px;
  display: inline-block;
  box-shadow: 1px 0 #00000040;
}

.stepper__text {
  color: #999;
  margin: 0 8px;
}

.stepper__text--active {
  color: #666;
}

.stepper__text--done {
  color: #333;
}

.stepper__link {
  box-sizing: border-box;
  align-items: center;
  min-width: 200px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
}

.stepper__link:after {
  content: "";
  opacity: .5;
  text-align: center;
  vertical-align: middle;
  background: #00000040;
  border-radius: 1px 0 0 1px;
  flex-grow: 1;
  align-self: center;
  height: 2px;
  line-height: 1px;
  display: inline-block;
  box-shadow: 1px 0 #00000040;
}

.stepper__link--first {
  margin-right: 8px;
}

.stepper__link--last {
  margin-left: 8px;
}

.stepper__count {
  --diameter: 30px;
  color: #fff;
  height: var(--diameter);
  font-size: 1.1em;
  font-weight: bold;
  line-height: calc(var(--diameter)  - 4px);
  text-align: center;
  width: var(--diameter);
  background: #bdbdbd;
  border: 2px solid #bdbdbd;
  border-radius: 15px;
  display: inline-block;
}

.stepper__count--active {
  background: #6c7e9d;
}

.stepper__count--not-done {
  border: 2px solid #6c7e9d;
}

.stepper__count--previous {
  color: #6c7e9d;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/Stepper/Stepper.css","webpack://./services/frontend/app/containers/Stepper/Stepper.css"],"names":[],"mappings":"AADA;ECEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".stepper {\n  margin: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n  .stepper:after {\n    align-self: center;\n    background: rgba(0, 0, 0, 0.25);\n    border-radius: 1px 0 0 1px;\n    box-shadow: 1px 0 0 0 rgba(0, 0, 0, 0.25);\n    content: '';\n    display: inline-block;\n    flex-grow: 1;\n    height: 2px;\n    line-height: 1px;\n    opacity: 0.5;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n.stepper__text {\n  margin: 0 8px;\n  color: #999;\n}\n\n.stepper__text--active {\n  color: #666;\n}\n\n.stepper__text--done {\n  color: #333;\n}\n\n.stepper__link {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  min-width: 200px;\n}\n\n.stepper__link:after {\n    align-self: center;\n    background: rgba(0, 0, 0, 0.25);\n    border-radius: 1px 0 0 1px;\n    box-shadow: 1px 0 0 0 rgba(0, 0, 0, 0.25);\n    content: '';\n    display: inline-block;\n    flex-grow: 1;\n    height: 2px;\n    line-height: 1px;\n    opacity: 0.5;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n.stepper__link--first {\n  margin-right: 8px;\n}\n\n.stepper__link--last {\n  margin-left: 8px;\n}\n\n.stepper__count {\n  --diameter: 30px;\n\n  background: #bdbdbd;\n  border: 2px solid #bdbdbd;\n  border-radius: 15px;\n  color: #fff;\n  display: inline-block;\n  font-size: 1.1em;\n  font-weight: bold;\n  height: var(--diameter);\n  line-height: calc(var(--diameter) - 4px);\n  text-align: center;\n  width: var(--diameter);\n}\n\n.stepper__count--active {\n  background: #6c7e9d;\n}\n\n.stepper__count--not-done {\n  border: 2px solid #6c7e9d;\n}\n\n.stepper__count--previous {\n  color: #6c7e9d;\n}\n",".stepper {\n  flex-direction: row;\n  margin: 10px;\n  display: flex;\n}\n\n.stepper:after {\n  content: \"\";\n  opacity: .5;\n  text-align: center;\n  vertical-align: middle;\n  background: #00000040;\n  border-radius: 1px 0 0 1px;\n  flex-grow: 1;\n  align-self: center;\n  height: 2px;\n  line-height: 1px;\n  display: inline-block;\n  box-shadow: 1px 0 #00000040;\n}\n\n.stepper__text {\n  color: #999;\n  margin: 0 8px;\n}\n\n.stepper__text--active {\n  color: #666;\n}\n\n.stepper__text--done {\n  color: #333;\n}\n\n.stepper__link {\n  box-sizing: border-box;\n  align-items: center;\n  min-width: 200px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.stepper__link:after {\n  content: \"\";\n  opacity: .5;\n  text-align: center;\n  vertical-align: middle;\n  background: #00000040;\n  border-radius: 1px 0 0 1px;\n  flex-grow: 1;\n  align-self: center;\n  height: 2px;\n  line-height: 1px;\n  display: inline-block;\n  box-shadow: 1px 0 #00000040;\n}\n\n.stepper__link--first {\n  margin-right: 8px;\n}\n\n.stepper__link--last {\n  margin-left: 8px;\n}\n\n.stepper__count {\n  --diameter: 30px;\n  color: #fff;\n  height: var(--diameter);\n  font-size: 1.1em;\n  font-weight: bold;\n  line-height: calc(var(--diameter)  - 4px);\n  text-align: center;\n  width: var(--diameter);\n  background: #bdbdbd;\n  border: 2px solid #bdbdbd;\n  border-radius: 15px;\n  display: inline-block;\n}\n\n.stepper__count--active {\n  background: #6c7e9d;\n}\n\n.stepper__count--not-done {\n  border: 2px solid #6c7e9d;\n}\n\n.stepper__count--previous {\n  color: #6c7e9d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
